// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { Environment } from '@models';

export const environment: Environment = {
  production: false,
  environmentName: 'SND',
  apiUrl: 'https://deqbautoapi-pre.verti.de',
  googleMapsApiKey: 'AIzaSyCYuaQa_zh-mK1MOI8SlqT-hp6G7Sqb-2s',
  activityRegistryApiUrl: 'https://deqbautoapi-pre.verti.de',
  activityRegistryApiKey: 'GXYCzdjffv7GOEfAy6MI352eEy41JAji8RFtqRQa',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// by default import 'zone.js/dist/zone-error';  // Included with Angular CLI.
